import { render, staticRenderFns } from "./UnitLang.vue?vue&type=template&id=bd9d06c4&scoped=true&"
import script from "./UnitLang.vue?vue&type=script&lang=js&"
export * from "./UnitLang.vue?vue&type=script&lang=js&"
import style0 from "./UnitLang.vue?vue&type=style&index=0&id=bd9d06c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9d06c4",
  null
  
)

export default component.exports